import { render } from "./fabricCompositionExcelGuide.vue?vue&type=template&id=6ba99b44&scoped=true&ts=true"
import script from "./fabricCompositionExcelGuide.vue?vue&type=script&lang=ts"
export * from "./fabricCompositionExcelGuide.vue?vue&type=script&lang=ts"

import "./fabricCompositionExcelGuide.vue?vue&type=style&index=0&id=6ba99b44&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba99b44"]])

export default __exports__